import StoreService from '@/store/StoreService'

export function useSpotify() {
  const { spotify } = StoreService.getStore()
  return spotify
}
